/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./project-demo.vue?vue&type=template&id=76445051&"
import script from "./project-demo.vue?vue&type=script&lang=ts&"
export * from "./project-demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports